<template>
  <div class="comp-book-request">
    <div class="trigger-wrapper" @click.stop="onClick">
      <slot></slot>
    </div>
    <el-dialog
      class="dialog"
      custom-class="my-dialog"
      :visible.sync="showForm"
      lock-scroll
      :close-on-click-modal="true"
      :fullscreen="isMobile"
      :append-to-body="true"
    >
      <el-form class="text-text dialog-form" :model="form" :rules="rules" ref="form">
        <div class="flex justify-between">
          <div class="text-2xl font-bold">Book a Viewing</div>
          <ProgressiveImage
            :src="close_primary_svg"
            alt="close"
            img-class="cursor-pointer fill-current"
            @click="showForm = false"
          />
        </div>
        <div class="pb-4">Darwin Green, Lawrence Weaver Road</div>
        <div class="text-lg font-bold">Basic Infomation</div>
        <div class="divide-x"></div>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-4">
          <el-form-item
            class="flex flex-col items-start"
            label="First Name"
            required
            prop="first_name"
          >
            <div class="flex">
              <el-select v-model="form.gender" placeholder="Please select">
                <el-option
                  v-for="item in gender"
                  :key="item.value"
                  :value="item.value"
                  :label="item.label"
                >
                </el-option>
              </el-select>
              <el-input v-model="form.first_name"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="Last Name" required prop="last_name">
            <el-input v-model="form.last_name"></el-input>
          </el-form-item>
          <el-form-item label="Email" required prop="email">
            <el-input v-model="form.email"></el-input>
          </el-form-item>
          <el-form-item label="Telephone" required prop="phone">
            <el-input v-model="form.phone"></el-input>
          </el-form-item>
        </div>
        <div class="pt-4 font-bold text-lg">Arrange a viewing of this property(optional)</div>
        <div class="divide-x"></div>
        <el-form-item class="flex flex-col items-stretch" label="Preferred date (optional)">
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-4 items-stretch">
            <el-date-picker
              style="width: 100%"
              v-model="form.preferred_date"
              type="date"
              placeholder="Pick a date"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
            <el-time-select
              style="width: 100%"
              v-model="form.preferred_time"
              :picker-options="{
                start: '09:00',
                step: '00:15',
                end: '18:00',
              }"
              placeholder="Pick a time"
            >
            </el-time-select>
          </div>
        </el-form-item>
        <el-form-item label="Message">
          <el-input type="textarea" :rows="4" v-model="form.message"></el-input>
        </el-form-item>
        <el-button class="app-button" @click="onConfirm">Confirm</el-button>
        <div class="pt-4 text-sm text-gray-500">
          By proceeding, you agree to the terms set out in our
          <a
            class="text-primary"
            href="/privacy-policy"
            target="_blank"
            aria-label="Read our Privacy Policy"
            >Privacy Policy</a
          >.
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import * as allIcons from '@/assets/images/icon';
import { Dialog, TimeSelect } from 'element-ui';
export default {
  components: {
    'el-dialog': Dialog,
    'el-time-select': TimeSelect,
  },
  props: {
    houseId: {
      type: Number,
      reuqired: true,
    },
  },
  data() {
    return {
      close_primary_svg: allIcons.closePrimary,
      showForm: false,
      form: {
        gender: '1',
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        preferred_date: '',
        preferred_time: '',
        message: '',
        architecture: '', // house id
      },

      rules: {
        gender: [{ required: true, message: 'Please select title' }],
        first_name: [{ required: true, message: 'Please enter first name' }],
        last_name: [
          { required: true, message: 'Please enter last name', trigger: ['blur', 'change'] },
        ],
        email: [
          { required: true, message: 'Please enter email', trigger: ['blur', 'change'] },
          { type: 'email', message: 'Invalid email', trigger: ['blur', 'change'] },
        ],
        phone: [
          { required: true, message: 'Please enter phone number', trigger: ['blur', 'change'] },
          { validator: this.validatePhone, trigger: ['blur', 'change'] },
        ],
      },
    };
  },
  methods: {
    onClick() {
      console.log('onClick comp');
      this.showForm = true;
      this.form.architecture = this.houseId;
    },
    onConfirm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            const res = await this.axios.post('/letting/client/contact_us', this.form);
            if (res.data.code != 1) {
              return this.$alert(res.data.msg || 'Failed');
            }
            this.$alert('Your request has been submitted successfully.');
            this.showForm = false;
          } catch (error) {
            this.$alert(error?.msg || error?.message || 'Failed to submit');
          }
        } else {
          this.$message({
            type: 'error',
            message: 'Please fill in the form correctly',
          });
        }
      });
    },
    validatePhone(rule, value, callback) {
      // const phoneRegex = /^1[3-9]\d{9}$/;
      const phoneRegex = /^\d+$/;
      if (!value) {
        callback(new Error('Please enter phone number'));
      } else if (!phoneRegex.test(value)) {
        callback(new Error('Invalid phone number'));
      } else {
        callback();
      }
    },
  },
  computed: {
    gender() {
      const title = this.$store.getters.setting.title;
      if (!title) return [];
      return Object.entries(title).map(([x, b]) => {
        return {
          label: b,
          value: x,
        };
      });
    },
    isMobile() {
      return document.body.clientWidth < 768;
    },
  },
};
</script>
<style lang="scss" scoped>
.comp-book-request {
  font-family: PuHuiTiMedium;
}
.app-button {
  margin-top: 2rem;
}
.dialog-form {
  overflow-y: scroll;
  scrollbar-color: var(--c-bg) #fff;
}

@media screen and (max-width: 768px) {
  .dialog-form {
    max-height: 100vh;
  }
}
</style>
<style lang="scss">
.my-dialog {
  &.el-dialog:not(.is-fullscreen) {
    margin-top: calc(50vh - 50%);
  }
  .el-dialog__body {
    padding: 2rem 3rem;
  }
  .el-form-item__label {
    text-align: left;
  }
  .el-form-item {
    margin-bottom: 0.5rem;
  }
  .el-dialog__header {
    display: none;
  }
}
</style>
